export class ProcessInputField {
    tag = 'unknownField';
    type: 'text' | 'number' | 'password' | 'select' | 'url' = 'text';
    label = '';
    reauthorizePlaceholder?: Record<string, string>;
    choices?: string[];
    required = true;
    validationErrors?: string[];

    deserialize(data: any): this {
        this.tag = data.tag ?? 'unknownField';
        this.type = data.type ?? 'text';
        this.label = data.label ?? this.getLabel(this.tag);
        this.reauthorizePlaceholder = data.reauthorize_placeholder ?? undefined;
        this.choices = data.choices ?? undefined;
        this.required = data.required ?? true;
        this.validationErrors = data.validation_errors ?? undefined;

        return this;
    }
    private getLabel(tag: string): string {
        switch (tag) {
            case 'password':
                return $localize`:@@password:Wachtwoord`;
            case 'username':
                return $localize`:@@username:Gebruikersnaam`;
            case 'otp_code':
                return $localize`:@@otpCode:OTP-code`;
            default:
                return tag;
        }
    }
}
